import React from 'react';
import {Layout, Divider} from 'antd';

import Header from './common/header/Header';
import Body from './pages/Body';
import './App.css';

const {Content} = Layout;

function App() {
    return (
        <div className="App">
            <Layout style={{minHeight: '100vh'}}>
                <Layout>
                    <Header/>
                    <Divider style={{margin: 0, borderTop: '1px solid #dce0e4'}}/>
                    <Content>
                        <Body/>
                    </Content>
                </Layout>
            </Layout>
        </div>
    );
}

export default App;
